import { ActivatedRoute, Router } from '@angular/router';
import { IDataUser, IInspectUser, ITokenEndpoint } from 'src/app/_helpers/interfaces/sso.interface';

import { AuthService } from 'src/app/services/http/auth.service';
import { Component } from '@angular/core';
import { ErrorInvalidSession } from 'src/app/_helpers/interfaces/IErrors';
import { LoginSsoService } from '../../services/login-sso.service';
import { UiService } from 'src/app/services/ui/ui.service';

@Component({
  selector: 'app-login-sso',
  template: ``
})
export class LoginSsoComponent {
  paramCode : any = this.routerParam?.snapshot.queryParamMap.get('code')
  genericTitle : string = 'Inicio con SSO'
  genericMessage : string = 'Lo sentimos, ocurrio un error al iniciar sesión con SSO'
  constructor(
    private loginSsoSrv : LoginSsoService,
    private routerParam : ActivatedRoute,
    private ui: UiService,
    private authSrv : AuthService,
    private router: Router,
  ) {
     if(this.paramCode){
      this.ui.showLoading('Iniciando con SSO')
      // this.ssoLocal(this.paramCode)
      this.sso(this.paramCode)
      return
     }
     this.router.navigateByUrl('auth');
  }

  sso(code : string){
    this.loginSsoSrv.generartokenSSO(code).subscribe({
      next: (response:IDataUser | any) => {
        this.ui.hiddeLoading();
        if(response.success === false){
          this.errorMessage(this.genericTitle, response.mensaje ?? this.genericMessage)
        }
        this.authSrv.setUser( response );
        this.menuCharge(response.path)
      },
      error: err =>{
        this.errorMessage(this.genericTitle, err.mensaje ?? this.genericMessage)      
      }
    })
  }
  
  ssoLocal(code : string){
    this.loginSsoSrv.generarTokenEndpoint(code).subscribe({
      next: (response : ITokenEndpoint) => {
        localStorage.setItem('refresh-token', response.refresh_token)
        this.dataUser(response.access_token)
      },
      error: err => {
        this.errorMessage( err.error ?? this.genericTitle, err.error_description ?? this.genericMessage)
      }
    })
  }
  
  dataUser(token : string){
    this.loginSsoSrv.introspectionEmail(token).subscribe({
      next: (response : IInspectUser) => { 
        this.saveToken(token, response.sub)
      },
      error: err => {
        this.errorMessage(err.status ?? this.genericTitle, err.message ?? this.genericMessage)
      }
    })
  }

  saveToken(token : string, correo : string){
    this.loginSsoSrv.saveToken(token, correo).subscribe({
      next: (response : IDataUser | any ) => {
        if(response.success === false){
          this.errorMessage(this.genericTitle, response.mensaje ?? this.genericMessage)
        }
        this.authSrv.setUser( response );
        this.menuCharge(response.path)
        
      },
      error: err => {
        this.errorMessage(this.genericTitle, err.mensaje ?? this.genericMessage)
      },
    })
  }

  menuCharge(path : string){
    const title : string = 'Permisos'
    const message : string = 'Lo sentimos, ocurrio un error al obtener tus permisos, por favor inicia sesión nuevamente.'
    this.authSrv.cargarMenu().subscribe({
      next: _respMenu => {
        if( !_respMenu.success ) {
          this.authSrv.cerrarSesion();
        this.errorMessage(title, _respMenu.mensaje ?? message)
        }
        this.authSrv.setMenu( _respMenu.permisos )
        this.router.navigateByUrl(path);
      },
      error: err => {
        this.authSrv.cerrarSesion();
        this.errorMessage(title, err.mensaje ?? message)
      }
    })
  }
  
  errorMessage(title : string, message : string){
    this.router.navigateByUrl('auth');
    this.ui.hiddeLoading();
    throw new ErrorInvalidSession( title, 'error', message)
  }
}
